import {needAuth} from "../instance/Instance";

async function getContractList(search, pageable) {
    console.log(">> 자산계약관리 List 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/asset/contract?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function getContractsNoPages(search) {
    try{
        const res = await needAuth.post('/asset/contract/nps' ,search);
        return  res;
    }catch (error){
        return error;
    }
}

async function removeContracts(ids) {
    try {
        return await needAuth.put('/asset/contract/delete', ids);
    }catch (error){
        return error;
    }
}

async function getContract(id) {
    try{
        return  await needAuth.get('/asset/contract/'+id);
    }catch (error){
        return error;
    }
}

async function saveContract(contract, files, assets) {
    
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });
    
    
    const update = assets?.map(item => ({id : item.id}));
    contract.assetIds = update;
    
    formData.append(
        "assetContractRequestDto",
        new Blob([JSON.stringify(contract)], { type: "application/json" })
    );

    try {
        return await needAuth.post(`/asset/contract/create`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error;
    }
}

async function updateContract(data) {
    try {
        return await needAuth.put(`/asset/contract`, data)
    }catch (error){
        return error;
    }
}

async function createContractAssets(contract, asset) {
    try{
        const contractAssets ={ contracts:{ id : contract }, assets : {id : asset.id} }
        return await needAuth.post(`/asset/contract/assets/create`, contractAssets);
    }catch (error) {
        return error;
    }
}

async function removeContractAssets(contract, asset) {
    try {
        return await needAuth.delete(`/asset/contract/assets/delete?contract=`+contract+`&asset=`+asset.id);
    }catch (error){
        return error;
    }
}

export {getContractList, removeContracts, saveContract, getContract, updateContract, removeContractAssets, createContractAssets, getContractsNoPages};